import ExaminationResultByRound from './ExaminationResultByRound';

export default ExaminationResultByRound;
